interface Props {
  value: number
  timestamp?: number
  suffix?: string
}

const Text = (props: Props) => {
  if (!props?.value) {
    return (
      <span
        style={{ fontWeight: 600, }}
      >
        거래없음.
      </span>
    )
  }
  return (
    <span
      style={{ fontWeight: 600, }}
    >
      {props.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')} {props?.suffix}
    </span>
    // <></>
  );
};

export default Text;
